import database from '../database'
import { showLanding } from '../../component/landing'

export class RoomDialog {
  show = () => {
    if (this.isDisplayed()) {
      return
    }

    const template = document.getElementById('dialogs')

    const dialog = template.content.querySelector('#roomDialog').cloneNode(true)
    dialog.removeAttribute('id')
    dialog.classList.add('room-dialog')

    const form = dialog.querySelector('form')
    form.addEventListener('submit', this.onFormSubmit)

    const closeBtn = dialog.querySelector('.dialog__close')
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        this.hide()
        showLanding()
      })
    }

    document.body.appendChild(dialog)
    dialog.showModal()
  }

  hide = () => {
    this.roomDialog?.remove()
  }

  /**
   * Handle dialog form validation
   *
   * @param {Event} evt
   */
  onFormSubmit = async (evt) => {
    evt.preventDefault()

    const { target: form } = evt

    const submit = form.querySelector('button[type=submit]')
    this.setError(false)

    submit.disabled = true

    try {
      const roomId = await database.createRoom()
      this.redirectToRoom(roomId)

      this.hide()
    } catch (err) {
      this.setError(err.toString())
    }
  }

  setError (errorMsg) {
    const form = this.roomDialog.querySelector('form')

    /** @type {HTMLButtonElement} */
    const submit = form.querySelector('button[type=submit]')

    /** @type {HTMLDivElement} */
    const error = form.querySelector('.form__error')

    if (errorMsg) {
      error.textContent = errorMsg
      submit.disabled = false
      submit.focus()
    } else {
      error.textContent = ''
    }
  }

  isDisplayed () {
    return !!this.roomDialog
  }

  isNotDisplayed () {
    return !this.isDisplayed()
  }

  redirectToRoom (roomId) {
    const url = new URL(window.location.toString())
    url.searchParams.set('roomId', roomId)

    window.location = url.toString()
  }

  /***
   *
   * @returns {HTMLDialogElement}
   */
  get roomDialog () {
    return document.querySelector('.room-dialog')
  }
}

export default new RoomDialog()
